export default __webpack_public_path__ + "static/ClientSide-568a9b293bc26d2f158bd35c5cf6973d.png";